$(function() {
  function raised_per_student() {
    return $('#per_student_slider').val();
  }

  function number_students() {
    return $('#number_students').val();
  }
  
  function participation_percentage(percentage) {
    return number_students() * percentage;
  }

  function total_raised(number_students) {
    return parseFloat(raised_per_student() * number_students * 0.65).toFixed(2);
  }

  function add_commas(value)
  {
    value += '';
    x = value.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  function display_calculator_results() {
    $('#per_student_raised').html("$" + raised_per_student());
    $('#25-calculator').html("$" + add_commas(total_raised(participation_percentage(0.25))));
    $('#35-calculator').html("$" + add_commas(total_raised(participation_percentage(0.35))));
    $('#45-calculator').html("$" + add_commas(total_raised(participation_percentage(0.45))));
  }

  $('#per_student_slider, #number_students').on('input', function() {
    display_calculator_results();
  });

  display_calculator_results();
})